import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-80 h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "input" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "input-label",
  style: {"width":"20%"}
}, [
  /*#__PURE__*/_createTextVNode("User ID"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(":")
], -1 /* HOISTED */)
const _hoisted_5 = {
  class: "error-message",
  style: {"color":"red","display":"{{errormessage.trim() == '' ? block: none}}"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_7 = { class: "news-admin-table table-bordered" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "header" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }, [
      /*#__PURE__*/_createElementVNode("div", { class: "text-center center-block" }, "User ID")
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }, [
      /*#__PURE__*/_createElementVNode("div", { class: "text-center center-block" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_9 = { class: "table-body" }
const _hoisted_10 = { style: {"width":"5%"} }
const _hoisted_11 = { style: {"width":"5%"} }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  style: {"height":"30%"}
}
const _hoisted_14 = { class: "modal-dialog" }
const _hoisted_15 = {
  class: "modal-content",
  style: {"height":"40%"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "deleteModalLabel"
  }, "Delete User ID"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-body",
  style: {"flex":"0 0 auto"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, "Are you sure to delete this user ID?")
], -1 /* HOISTED */)
const _hoisted_18 = { class: "modal-footer" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  id: "deleteCancel"
}, " Cancel ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Alert"], {
      "alert-message": $setup.alertMessage,
      "alert-state": $setup.alertState
    }, null, 8 /* PROPS */, ["alert-message", "alert-state"]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.menuTitle }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "input-area form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.userId]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary addBtn text-center",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickAddButton()))
      }, " Add ")
    ]),
    _createElementVNode("span", _hoisted_5, _toDisplayString($setup.errormessage), 1 /* TEXT */),
    _hoisted_6,
    _createElementVNode("table", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("tbody", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsAdminList, (info, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", _hoisted_10, _toDisplayString(info.userId), 1 /* TEXT */),
            _createElementVNode("td", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-primary delete text-center",
                "data-bs-toggle": "modal",
                "data-bs-target": "#deleteModal",
                onClick: ($event: any) => ($setup.getDeleteUserId(info.userId, info.destCode))
              }, " Delete ", 8 /* PROPS */, _hoisted_12)
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary footer-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClickDeleteButton($setup.deleteUserId, $setup.deleteDestCode)))
            }, " Delete ")
          ])
        ])
      ])
    ])
  ]))
}